"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClient = exports.IframeConnector = void 0;
const tslib_1 = require("tslib");
const plugin_1 = require("@remixproject/plugin");
const theme_1 = require("./theme");
class IframeConnector {
    constructor(options) {
        this.options = options;
    }
    /** Send a message to the engine */
    send(message) {
        if (this.source) {
            this.source.postMessage(message, this.origin);
        }
        else if (plugin_1.isHandshake(message)) {
            window.parent.postMessage(message, '*');
        }
    }
    /** Get messae from the engine */
    on(cb) {
        window.addEventListener('message', (event) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!event.source)
                return;
            if (!event.data)
                return;
            if (!plugin_1.isPluginMessage(event.data))
                return;
            // Check that the origin is the right one
            const isGoodOrigin = yield plugin_1.checkOrigin(event.origin, this.options);
            if (!isGoodOrigin)
                return console.warn('Origin provided is not allow in message', event);
            if (plugin_1.isHandshake(event.data)) {
                this.source = event.source;
                this.origin = event.origin;
            }
            cb(event.data);
        }), false);
    }
}
exports.IframeConnector = IframeConnector;
/**
 * Connect an Iframe client to a web engine
 * @param client An optional iframe client to connect to the engine
 * @example Let the function create a client
 * ```typescript
 * const client = createClient()
 * ```
 * @example With a custom client
 * ```typescript
 * class MyPlugin extends PluginClient {
 *  methods = ['hello']
 *  hello() {
 *   console.log('Hello World')
 *  }
 * }
 * const client = createClient(new MyPlugin())
 * ```
 */
exports.createClient = (client = new plugin_1.PluginClient()) => {
    const c = client;
    const options = client.options;
    const connector = new IframeConnector(options);
    plugin_1.connectClient(connector, c);
    plugin_1.applyApi(c);
    if (!options.customTheme) {
        theme_1.listenOnThemeChanged(c);
    }
    return c;
};
//# sourceMappingURL=connector.js.map